import { Map, List } from 'immutable';
import Behavior from './behavior';
export class BehaviorsCollection {
    constructor(behaviorObjs) {
        const behaviorList = List(behaviorObjs).map(obj => new Behavior(obj));
        this._behaviorMap = Map().withMutations(map => {
            behaviorList.reduce((m, behavior) => {
                if (behavior.id) {
                    return m.set(behavior.id, behavior);
                }
                else {
                    return m;
                }
            }, map);
        });
    }
    behaviorForId(id) {
        return this._behaviorMap.get(id);
    }
    includes(id) {
        return Boolean(this.behaviorForId(id));
    }
    size() {
        return this._behaviorMap.size;
    }
}
export const getBehaviorsCollectionFromGraphQL = (behaviors) => new BehaviorsCollection(getMappedBehaviors(behaviors));
const getMappedBehaviors = (behaviors) => {
    if (behaviors) {
        return behaviors.map(({ id, behaviorId, ...rest }) => {
            if (rest) {
                return {
                    id: behaviorId || id,
                    payload: {
                        ...rest,
                    },
                };
            }
            else {
                return {
                    id: behaviorId || id,
                };
            }
        });
    }
    return [];
};
export default BehaviorsCollection;
